module.exports = __webpack_public_path__ + "static/media/tim_zhou.23937341.jpg";